<template>
  <div class="content-div">
    <div class="form-box">
      <el-form :rules="rules" ref="ruleForm" :model="drawerForm" label-width="90px">
        <div class="top-title">基础信息</div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="机构名称 : " prop="orgName">
              <el-input v-model="drawerForm.orgName" style="width: 100%" placeholder="请输入" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="机构全称 : " prop="orgFullName">
              <el-input v-model="drawerForm.orgFullName" style="width: 100%" placeholder="请输入" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="机构类型 : " prop="orgType">
              <el-select v-model="drawerForm.orgType" placeholder="请选择" style="width: 100%" size="small">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="机构排序 : ">
              <el-input-number v-model="drawerForm.sort" size="mini" style="width: 100%" :min="1" :max="1000"
                               label="描述文字"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="false">
          <el-col :span="12">
            <el-form-item label="所属企业 : ">
              <el-cascader
                  style="width: 100%"
                  :show-all-levels="false"
                  :props="defaultProps"
                  size="mini"
                  v-model="drawerForm.parentCodes"
                  :options="cascaderOptions"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="bottom-btn">
      <el-button :loading="submitType" @click="submitData(1)" type="primary" size="mini">确定</el-button>
      <el-button @click="submitData(2)" size="mini">取消</el-button>
    </div>
  </div>
</template>

<script>
import {getAreaTree, addArea, updateArea} from "../../../common/enterpriseApi";

export default {
  name: "enterpriseDialog",
  props: {
    drawerForm: {
      type: Object,
    },
    dialogType: {
      type: Number
    }
  },
  data() {
    return {
      rules: {
        orgName: [
          {required: true, message: '请输入机构名称', trigger: 'blur'},
          {max: 50, message: '最多可输入50个字符', trigger: 'blur'}
        ],
        orgFullName: [
          {required: true, message: '请输入机构全称', trigger: 'blur'},
          {max: 50, message: '最多可输入50个字符', trigger: 'blur'}
        ],
        orgType: [
          {required: true, message: '请选择机构类型', trigger: 'change'}
        ],
      },
      options: [
        {
          value: 0,
          label: '公司'
        }, {
          value: 1,
          label: '部门'
        },],
      submitType: false,
      cascaderOptions: [],
      defaultProps: {
        children: 'menuChildren',
        value: 'orgCode',
        label: 'orgName',
        checkStrictly: true
      }
    }
  },
  mounted() {
    this.getAreaTree()
  },
  methods: {
    // 数据提交
    async submitData(type) {
      if (type === 1) {
        /*
        * dialogType
        * 1   新增
        * 2   修改
        * */
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            this.submitType = true
            if (this.drawerForm.parentCodes && this.drawerForm.parentCodes.length) {
              this.$set(this.drawerForm, 'parentCode', this.drawerForm.parentCodes[this.drawerForm.parentCodes.length - 1])
              // delete this.drawerForm.parentCodes
            }
            if (this.dialogType === 1) {
              try {
                const res = await addArea(this.drawerForm)
                if (res.code === 200) {
                  this.$notify.success({
                    title: '成功提示',
                    message: '企业新增成功'
                  })
                  this.submitType = false
                  this.$emit('drawerClose')
                } else {
                  this.$notify.error({
                    title: '错误提示',
                    message: res.msg
                  })
                  this.submitType = false
                }
              } catch (e) {
                this.submitType = false
                console.log(e)
              }
            } else {
              try {
                const res = await updateArea(this.drawerForm)
                if (res.code === 200) {
                  this.$notify.success({
                    title: '成功提示',
                    message: '企业修改成功'
                  })
                  this.submitType = false
                  this.$emit('drawerClose')
                } else {
                  this.$notify.error({
                    title: '错误提示',
                    message: res.msg
                  })
                  this.submitType = false
                }
              } catch (e) {
                this.submitType = false
                console.log(e)
              }
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      } else {
        this.$emit('drawerClose')
      }
    },
    // 获取企业列表
    async getAreaTree() {
      try {
        const res = await getAreaTree()
        if (res.code === 200) {
          this.cascaderOptions = res.data
        } else {
          this.$notify.error({
            title: '错误提示',
            message: res.msg
          })
        }
      } catch (e) {
        console.log(e)
      }
    },
  }
}
</script>

<style scoped>
.content-div /deep/ .el-form-item__error {
  padding-top: 0 !important;
}

.content-div {
  width: 100%;
  height: calc(100% - 40px);
}

.top-title {
  text-align: left;
  margin-bottom: 20px;
  margin-top: 20px;
  font-size: 18px;
  font-weight: 700;
}

.bottom-btn {
  position: absolute;
  bottom: 20px;
  right: 20px;
}

.form-box {
  box-sizing: border-box;
  padding: 0 60px 0 20px;
}

.form-box /deep/ .el-form-item {
  margin-bottom: 10px !important;
}
</style>
